export const formatTime = (totalSeconds) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');

  return `${formattedMinutes}:${formattedSeconds}`;
};

export const getSecondsDifference = (timestamp) => {
  const givenTime = new Date(timestamp);
  const now = new Date();
  const differenceInSeconds = Math.abs((now - givenTime) / 1000);
  return Math.floor(differenceInSeconds);
};
